// extracted by mini-css-extract-plugin
module.exports = {"ut-date-picker":"ut-date-picker"};